.skillsContainer {
  display: flex;
  flex-direction: column;
  gap: var(--spacingLg);
}
